import React from 'react';
import { BACK_BTN_LABEL, FormBuilder, SUBMIT_BTN_LABEL } from 'commons-ui';

import { EDIT_FORM_FIELD_CONFIG, EDIT_FORM_LAYOUT_CONFIG, editPlatformFeatureValidationSchema } from '../../formConfig';

import useEdit from './useEdit';

const EditSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			validationSchema={editPlatformFeatureValidationSchema}
			fieldConfig={EDIT_FORM_FIELD_CONFIG}
			layoutConfig={EDIT_FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: BACK_BTN_LABEL, submitLabel: SUBMIT_BTN_LABEL }}
		/>
	);
};

export default EditSegment;
